import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  changeGiftMe,
  changeBonusMe,
  setPageStatus,
  setGiftRef,
} from "../redux/slices/navSlice";
import {
  setRecipName,
  setRecipEmail,
  setDeliveryDate,
  setGiftMessage,
  setSendersName,
} from "../redux/slices/recipSlice";
import validator from "validator";
import InputLayout from "../../../ui/molecules/InputLayout.tsx";
const RecipientForm = ({ userInfo }) => {
  const dispatch = useDispatch();
  const bonus = useSelector((state) => state.company.presenter);
  const recip = useSelector((state) => state.recip);
  const nav = useSelector((state) => state.nav);
  const user = useSelector((state) => state.user);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setFocus,
  } = useForm();
  const onSubmit = (data) => {
    dispatch(setRecipName(data.name));
    dispatch(setRecipEmail(data.email));
    dispatch(setSendersName(data.sendersName));
    dispatch(setGiftMessage(data.message));
    if (!nav.emailMeGift) {
      dispatch(setDeliveryDate(data.date));
      dispatch(setRecipEmail(data.email));
    }
    dispatch(setPageStatus(user.user ? "payment" : "gift_page_2"));
  };

  function convertDateToUTC(date) {
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
    );
  }

  function today() {
    var date = new Date();
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    var datestr = date.toISOString().substring(0, 10);
    return datestr;
  }

  function isFutureDate(value) {
    if (nav.emailMeGift) {
      return true;
    }
    let d_now = new Date();
    d_now.setHours(0, 0, 0, 0);
    const dater = value.split("-");
    let d_inp = new Date(value);

    return d_now.getTime() <= convertDateToUTC(d_inp).getTime();
  }

  React.useEffect(() => {
    if (nav.emailMeGift) {
      dispatch(setDeliveryDate(""));
      dispatch(setRecipEmail(""));
      dispatch(setSendersName(""));
    } else {
      dispatch(setDeliveryDate(today()));
    }
  }, [nav.emailMeGift]);

  React.useEffect(() => {
    nav.giftRef && setFocus(nav.giftRef);
  }, [setFocus, nav.giftRef]);

  return (
    <form className="inner-col" onSubmit={handleSubmit(onSubmit)}>
      <div>
        <div className="checkout-head">Recipient Info</div>
        <div className="check-box-checkout">
          <input
            type="checkbox"
            id="sendtome"
            checked={nav.emailMeGift}
            onChange={() => dispatch(changeGiftMe())}
          />
          <label htmlFor="sendtome" className="send-to-me">
            Send gift to me to print, not recipient’s email.
          </label>
        </div>
      </div>
      <div className="checkout-form">
        <InputLayout
          label={"Sender's Name"}
          error={errors.name?.type === "required" && "Name is required"}
        >
          <input
            id="sender's name"
            type="text"
            aria-label="Sender's Name"
            defaultValue={userInfo?.first_name ?? recip.sendersName}
            {...register("sendersName", { required: true })}
            placeholder=" "
            className="floating-label-input"
          />
        </InputLayout>
        <InputLayout
          label={"Recipient's Name"}
          error={errors.name?.type === "required" && "Name is required"}
        >
          <input
            id="recipient's name"
            type="text"
            aria-label="Recipient's Name"
            defaultValue={recip.recipientName}
            {...register("name", { required: true })}
            placeholder=" "
            className="floating-label-input"
          />
        </InputLayout>

        <InputLayout
          label={"Recipient's Email"}
          showLabel={!nav.emailMeGift}
          error={
            errors.email?.type === "required"
              ? "An email address is required"
              : errors.email?.type === "validate"
                ? "Invalid email"
                : null
          }
        >
          <input
            id="Recipient's Email"
            type="email"
            aria-label="Recipient's Email"
            readOnly={nav.emailMeGift}
            defaultValue={recip.recipientEmail}
            {...register("email", {
              required: !nav.emailMeGift,
              validate: (value) => {
                if (!nav.emailMeGift) {
                  return validator.isEmail(value);
                } else {
                  return true;
                }
              },
            })}
            placeholder=" "
            className={`floating-label-input ${
              nav.emailMeGift && "filled-input"
            }`}
          />
        </InputLayout>
        <InputLayout
          label={"Delivery Date"}
          showLabel={!nav.emailMeGift}
          error={
            errors.date?.type === "required" && !nav.emailMeGift
              ? "Delivery date is required"
              : errors.date?.type === "validate" && !nav.emailMeGift
                ? "Date must be today or in the future"
                : null
          }
        >
          <input
            id="Delivery Date"
            type={nav.emailMeGift ? "text" : "date"}
            max="2999-12-31"
            aria-label="Delivery Date"
            readOnly={nav.emailMeGift}
            defaultValue={!nav.emailMeGift ? recip.deliveryDate : ""}
            {...register("date", {
              required: !nav.emailMeGift,
              validate: (value) => isFutureDate(value),
            })}
            style={{ textAlign: "left" }}
            placeholder=" "
            className={`floating-label-input ${
              nav.emailMeGift && "filled-input"
            }`}
          />
        </InputLayout>
        <InputLayout label={"Gift Message"}>
          <input
            id="gift message"
            type="text"
            aria-label="Gift Message"
            maxLength={6500}
            defaultValue={!nav.emailMeGift ? recip.giftMessage : ""}
            {...register("message", { required: false })}
            placeholder=" "
            className="floating-label-input"
          />
        </InputLayout>
        <button aria-label="continue" type="submit" className="big-blue-button">
          Continue
        </button>
      </div>
    </form>
  );
};

export default RecipientForm;
